import { Box, TextField, Typography, Paper } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/store";
import { setDetails } from "../../../Redux/slices/JobPostCreationSlice";

const MAX_CHARS = 150;

const DetailsStep = ({ value, onChange }: { value: string; onChange: (val: string) => void }) => {
  const dispatch = useAppDispatch();
  const [focused, setFocused] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
    dispatch(setDetails(newValue));
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh">
      <Typography variant="h4" align="center" fontWeight={600} mb={2}>
        Tell us about your project
      </Typography>
      <Typography variant="body1" color="text.secondary" align="center" mb={4}>
        Share a brief description of what you're looking for
      </Typography>
      <Paper 
        elevation={focused ? 3 : 1}
        sx={{ 
          width: "100%", 
          maxWidth: 600, 
          mb: 2,
          borderRadius: 4,
          transition: 'all 0.2s ease-in-out',
          backgroundColor: focused ? 'white' : 'grey.50',
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="E.g. Looking for a skilled developer to create an e-commerce website for my furniture business. Need someone who can handle both frontend and backend development."
          value={value}
          onChange={handleChange}
          inputProps={{ 
            maxLength: MAX_CHARS, 
            style: { 
              fontSize: 18, 
              padding: '20px 24px',
              lineHeight: 1.5
            } 
          }}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          multiline
          rows={3}
          sx={{
            '& fieldset': { 
              border: 'none',
              borderRadius: 4,
            },
            '& .MuiOutlinedInput-root': {
              borderRadius: 4,
            },
          }}
        />
      </Paper>
      <Box display="flex" justifyContent="flex-end" width="100%" maxWidth={600}>
        <Typography 
          variant="caption" 
          color={value.length === MAX_CHARS ? "error" : "text.secondary"}
          sx={{ 
            transition: 'color 0.2s ease-in-out',
            fontWeight: value.length === MAX_CHARS ? 600 : 400 
          }}
        >
          {MAX_CHARS - value.length} characters remaining
        </Typography>
      </Box>
    </Box>
  );
};

export default DetailsStep; 